export default function getTotalPaidTicketQuantity(selectedTicketTypes) {
  return selectedTicketTypes.reduce((total, ticket) => {
    if (ticket.price > 0) {
      return total + ticket.quantity;
    }

    return total;
  }, 0);
}
